import cn from 'classnames';
import React from 'react';

function Attention() {
  return (
    <div
      className={cn('absolute left-[50%] top-[50%] -ml-16 -mt-16 w-32 h-32')}
    >
      <div className={cn('h-full relative z-0 overflow-hidden')}>
        <div className={cn('relative w-full h-full rounded-full')}>
          <div
            className={cn(
              'pointer-events-none bg-black dark:bg-white opacity-0 absolute left-[50%] top-[50%] -ml-[12.5%] -mt-[12.5%] -z-[1] w-1/4 h-1/4 rounded-full sonar-wave1',
            )}
          ></div>
          <div
            className={cn(
              'pointer-events-none br-black dark:bg-white opacity-0 absolute left-[50%] top-[50%] -ml-[12.5%] -mt-[12.5%] -z-[1] w-1/4 h-1/4 rounded-full sonar-wave2',
            )}
          ></div>
        </div>
      </div>
    </div>
  );
}

export default Attention;
